<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>中华人民共和国企业所得税年度纳税申报表</dt>

      <dd>
        <div>税款所属期间：{{ staticConfig.taxStartTime }} 至 {{ staticConfig.taxEndTime }}</div>
        <div>（A类 , 2017年版） 金额单位：元，至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table tabletype="2024033107" border="1" cellspacing="0" cellpadding="4">
        <tbody>
          <tr class="tr">
            <td class="title01" width="280">纳税人识别号:（统一社会信用代码）</td>
            <td class="read" width="220">
              {{ staticConfig.creditCode ?? data.v1x1.value }}
            </td>
            <td class="title01" width="120">纳税人名称：</td>
            <td class="read">
              {{ staticConfig.companyName ?? data.v1x2.value }}
            </td>
          </tr>
          <tr class="tr">
            <td class="edit" colspan="5">
              谨声明：本纳税申报表是根据国家税收法律法规及相关规定填报的，是真实的、可靠的、完整的。 纳税人（签章）：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20**年**月**日
            </td>
          </tr>
        </tbody>
      </table>

      <table style="margin-top: 16px" border="1" cellspacing="0" cellpadding="4">
        <tbody>
          <tr class="tr">
            <td class="title01">经办人:</td>
            <td>***</td>
            <td class="title01">受理人:</td>
            <td>**电子税务局</td>
          </tr>
          <tr class="tr">
            <td class="title01">经办人身份证:</td>
            <td></td>
            <td class="title01">受理税务机关（章）:</td>
            <td>国家税务总局***税务局***税务所</td>
          </tr>
          <tr class="tr">
            <td class="title01">代理机构签章:</td>
            <td></td>
            <td class="title01">受理日期:</td>
            <td>20**-**-**</td>
          </tr>
        </tbody>
      </table>

      <p style="text-align: right">国家税务总局监制</p>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};
function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss"></style>

<script>
const tableHtml = `
<table tabletype="2024033107" border="1" cellspacing="0" cellpadding="4">
  <tbody>
    <tr class="tr">
      <td class="title01" width="280">
        纳税人识别号:（统一社会信用代码）
      </td>
      <td class="read" width="220">
        <input class="input1" type="text" id="nsrsbh" value="" readonly="">
      </td>
      <td class="title01" width="120">纳税人名称：</td>
      <td class="read">
        <input class="input1" type="text" id="nsrmc" value="" readonly="">
      </td>
    </tr>
    <tr class="tr">
      <td class="edit" colspan="5">
        <div class="declare">
          <div class="declareTxt">
            谨声明：本纳税申报表是根据国家税收法律法规及相关规定填报的，是真实的、可靠的、完整的。
          </div>
          <div style="text-align: right">
            纳税人（签章）：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20**年**月**日
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<table style="margin-top:16px; " border="1" cellspacing="0" cellpadding="4">
  <tbody>
    <tr class="tr">
      <td class="title01">
        经办人:
      </td>
      <td>
        ***
      </td>
      <td class="title01">受理人:</td>
      <td>
        **电子税务局
      </td>
    </tr>
    <tr class="tr">
      <td class="title01">经办人身份证:</td>
      <td></td>
      <td class="title01">受理税务机关（章）:</td>
      <td>
        国家税务总局***税务局***税务所
      </td>
    </tr>
    <tr class="tr">
      <td class="title01">代理机构签章:</td>
      <td></td>
      <td class="title01">受理日期:</td>
      <td>
        20**-**-**
      </td>
    </tr>
  </tbody>
</table>

<p style="text-align: right;">国家税务总局监制</p>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
